@charset "UTF-8";

/* src/app/shared/components/dialog-working/dialog-working.component.scss */
.mat-mdc-dialog-content {
  padding: 24px;
}
.mat-mdc-dialog-title {
  padding-bottom: 16px;
}
.mat-mdc-dialog-actions {
  padding-top: 16px;
}
.mat-mdc-button {
  margin: 0 auto;
}
/*# sourceMappingURL=dialog-working.component.css.map */
